/**
 * The Table view: a bordered grid of cells.
 *
 * radix-ui icons (MIT). fill is currentColor so it takes the colour of the
 * control it sits in -- the view switcher flips between white on green and grey.
 */
export const TableGridIcon = (props) => (
  <svg fill="currentColor" height={16} viewBox="0 0 15 15" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M8 2H12.5C12.7761 2 13 2.22386 13 2.5V5H8V2ZM7 5V2H2.5C2.22386 2 2 2.22386 2 2.5V5H7ZM2 6V9H7V6H2ZM8 6H13V9H8V6ZM8 10H13V12.5C13 12.7761 12.7761 13 12.5 13H8V10ZM2 12.5V10H7V13H2.5C2.22386 13 2 12.7761 2 12.5ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5Z"
      fillRule="evenodd"
    />
  </svg>
);
